import React, { Component} from 'react'
import { connect } from 'react-redux'
import { withRouter} from 'react-router-dom'
import {showLiveViewNotification,hideLiveViewNotification} from '../../actions/liveViewNotification'
import {showLiveViewModal} from '../../utils/liveViewModal'
import LiveViewNotification from '../../components/liveView/LiveViewNotification'
import {getSetPollForControl} from '../../utils/getPollForControl'
import find from 'lodash/find'



class LiveViewNotificationContainer extends Component {

	constructor() {
		super()		
		this.showLiveViewModal=this.showLiveViewModal.bind(this)
		this.startTimer = this.startTimer.bind(this)
		this.countDown = this.countDown.bind(this)
		this.hideLiveViewNotification = this.hideLiveViewNotification.bind(this)
		this.timer = 0

		this.state = { 
			seconds: 5
		}
	}

 
	UNSAFE_componentWillReceiveProps(nextProps) {
		//TODO clean up this logic for hiding/showing notification
		if(this.props.control && nextProps.control){
			if(this.props.control.controlled && ((!this.props.control.setPoll && nextProps.control.setPoll) || (!this.props.control.currentPoll && nextProps.control.currentPoll))){
				const {location}=this.props.history
				if(location.pathname !=='/nowplaying' && location.pathname!=='/nowplaying/' && location.hash!=='#now-playing' && location.pathname !=='/scan-helper' ){
					if(nextProps.control.mobileAccepted){
						this.props.showLiveViewNotification()
						this.startTimer()
					}
				}
			} 
			if((!nextProps.control.setPoll && !nextProps.control.currentPoll)&&(
				(!nextProps.control.setPoll && this.props.control.setPoll) || (!nextProps.control.currentPoll && this.props.control.currentPoll))){
				this.hideLiveViewNotification()
			} 
		}

	}

	shouldComponentUpdate(nextProps,nextState){
		if(
			nextProps.control!==this.props.control
			|| nextProps.liveViewNotification!==this.props.liveViewNotification
			|| nextState !==this.state

		){
			return true
		}else return false
	}


	startTimer() {
		if (this.timer === 0) {
			this.timer = setInterval(this.countDown, 1000)
		}
	}


	countDown() {
		let seconds = this.state.seconds - 1
		this.setState({
			seconds: seconds,
		})
		
		if (seconds === 0) { 
			clearInterval(this.timer)
			this.timer=0
			this.props.hideLiveViewNotification()
			this.setState({seconds:5})
			showLiveViewModal()


		}
	}

	showLiveViewModal(){
		this.props.hideLiveViewNotification()
		showLiveViewModal()
	}

	hideLiveViewNotification(){
		this.props.hideLiveViewNotification()
		clearInterval(this.timer)
		this.timer=0
		this.setState({seconds:5})

	}

	
	render() {
		const {control,section,liveViewNotification}=this.props
		if(liveViewNotification){
			 const setPoll=getSetPollForControl(control)
			return (        												  
				<LiveViewNotification 
					hideLiveViewNotification={this.hideLiveViewNotification}
					showLiveViewModal={this.showLiveViewModal}
					seconds={this.state.seconds}
					control={control}
					setPoll={setPoll}
					section={section}
				/>   				
			)
		}else return null
	}
}


function mapStateToProps(state) {
	const control=state.control
	let section=null
	if(state.control){
		section=find(state.sections, {'id':state.control.section})
	}
	



	return {
		 control:control,
		 section:section,
		 liveViewNotification:state.liveViewNotification,

	}
}




export default withRouter(connect(
	mapStateToProps,
	{ showLiveViewNotification,hideLiveViewNotification}
)(LiveViewNotificationContainer))


// WEBPACK FOOTER //
// ./src/containers/liveView/LiveViewNotificationContainer.js